









const twoPi = 2 * Math.PI;

export default {
  props: {
    progress: {
      type: Number,
    },
    radius: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      circumference: twoPi * this.radius,
    };
  },
  computed: {
    dashArray() {
      const percentage = this.progress / 100;
      const offset = this.circumference * percentage;
      return `${offset} ${this.circumference}`;
    },
  },
} as IView;
